import { render, staticRenderFns } from "./SectionWithCallToAction.vue?vue&type=template&id=393b918c&"
import script from "./SectionWithCallToAction.vue?vue&type=script&lang=js&"
export * from "./SectionWithCallToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports